var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 143,
    viewBox: "0 0 64 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_308_2658)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0536 142.317L31.2702 141.025C31.2702 141.025 31.7321 121.738 24.811 120.354C20.197 115.001 25.5493 -106.659 42.1595 119.615C42.1595 119.615 36.4385 122.476 35.4232 127.367C34.3154 132.166 35.0536 142.317 35.0536 142.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0536 142.317L31.2702 141.025C31.2702 141.025 31.7321 121.738 24.811 120.354C20.197 115.001 25.5493 -106.659 42.1595 119.615C42.1595 119.615 36.4385 122.476 35.4232 127.367C34.3154 132.166 35.0536 142.317 35.0536 142.317Z",
    fill: "#A6A385"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0842 123.676C37.0842 123.676 70.2131 101.897 62.4614 56.5867C54.9869 23.6426 37.3605 12.8457 35.423 8.69273C33.3008 5.73988 31.27 0.572388 31.27 0.572388L32.6549 92.2074C32.6549 92.2998 29.7936 120.261 37.0842 123.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0842 123.676C37.0842 123.676 70.2131 101.897 62.4614 56.5867C54.9869 23.6426 37.3605 12.8457 35.423 8.69273C33.3008 5.73988 31.27 0.572388 31.27 0.572388L32.6549 92.2074C32.6549 92.2998 29.7936 120.261 37.0842 123.676Z",
    fill: "#499D4A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3326 124.875C29.3326 124.875 -1.76643 103.65 0.0795317 66.2768C1.83225 28.9025 23.7956 10.5387 28.0401 7.21633C30.809 4.26348 30.9014 3.15573 31.0862 0.202881C33.0237 4.35587 32.655 62.3086 32.9313 69.1372C33.7619 95.4375 31.4549 119.893 29.3326 124.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3326 124.875C29.3326 124.875 -1.76643 103.65 0.0795317 66.2768C1.83225 28.9025 23.7956 10.5387 28.0401 7.21633C30.809 4.26348 30.9014 3.15573 31.0862 0.202881C33.0237 4.35587 32.655 62.3086 32.9313 69.1372C33.7619 95.4375 31.4549 119.893 29.3326 124.875Z",
    fill: "#58AA50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_308_2658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 143,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.38c7553c9e0cd1aa1a21a88dded84533.svg";
export { ForwardRef as ReactComponent };